import classNames from 'classnames';

import styles from './_index.module.scss';

export interface FillProps extends React.HTMLAttributes<HTMLElement> {}

const Fill = <T extends React.ElementType>({
  as,
  className,
  ...props
}: FillProps & PolymorphicProps<T>) => {
  const Component = as || 'div';
  return <Component className={classNames(styles['fill'], className)} {...props} />;
};

export default Fill;
